/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { Column } from "../../../common/commonComponents/mediaPreparationTable";

export const getColumns = (t: any): Column[] => [
  {
    header: t("mediaPrepBatch.tableColumns.sl_no"),
    key: "slno",
  },
  {
    header: t("mediaPrepBatch.tableColumns.batch_id"),
    key: "media_batch_identifier",
    render: (row) => (
      <td className="px-6 py-2">
        <span className="px-2.5 py-1.5 bg-slate-100 text-slate-900 font-mono font-medium text-[11px] uppercase tracking-wider rounded-md border border-slate-200 shadow-sm whitespace-nowrap">
          {row.id}
        </span>
      </td>
    ),
  },

  {
    header: t("mediaPrepBatch.tableColumns.media_type"),
    key: "media_type",
    render: (row) => (
      <td className="px-6 py-2">
        <span className="font-medium text-slate-700 text-sm tracking-tight whitespace-nowrap">
          {row.mediaType || "-"}
        </span>
      </td>
    ),
  },

  {
    header: t("mediaPrepBatch.tableColumns.qa_status"),
    key: "status",
    render: (row) => {
      const status = row.status;

      const style =
        status === "Draft"
        ? "bg-slate-100 text-slate-700 border-slate-200"
        : status === "In Preparation"
        ? "bg-blue-100 text-blue-700 border-blue-200"
        : status === "Media Dispensed"
        ? "bg-pink-100 text-pink-700 border-pink-200"
        : status === "Sterilized"
        ? "bg-yellow-100 text-yellow-700 border-yellow-200"
        : status === "Fine Tuned"
        ? "bg-purple-100 text-purple-700 border-purple-200"
        : status === "Released"
        ? "bg-green-100 text-green-700 border-green-200"
        : status === "Ready to Use"
        ? "bg-emerald-100 text-emerald-700 border-emerald-200"
        : status === "Rejected"
        ? "bg-red-100 text-red-700 border-red-200"
        : "bg-orange-100 text-[#FF7043] border-orange-200";

      return (
        <td className="px-6 py-2 whitespace-nowrap">
          <span
            className={`px-2.5 py-0.5 rounded-full text-[10px] font-medium uppercase border ${style}`}
          >
            {status || "-"}
          </span>
        </td>
      );
    },
  },

  {
    header: t("mediaPrepBatch.tableColumns.prepared_by"),
    key: "prepared_by",
    render: (row) => (
      <td className="px-6 py-2">
        <span className="text-slate-500 text-sm whitespace-nowrap">
          {row.preparedBy || "-"}
        </span>
      </td>
    ),
  },

  {
    header: t("mediaPrepBatch.tableColumns.created_date"),
    key: "created_at",
    render: (row) => (
      <td className="px-6 py-2">
        <span className="text-slate-400 font-mono text-xs whitespace-nowrap">
          {row.dateCreated}
        </span>
      </td>
    ),
  },
];